import styled from 'styled-components';

/**
 * The `.card` surface. One border, one radius, one shadow — replaces the
 * 15px-radius / #00000005-shadow box that was the app's only surface.
 *
 * Structure mirrors the design's card:
 *   .card          → BoxContainer
 *   .section-head  → Head       (title, optional hint, right-hand action slot)
 *   .card-body     → Content
 *
 * Add className="flush" when the child should meet the card edge — tables and
 * detail grids draw their own separators.
 *
 * Add className="bare" when something else already draws the card. A filter
 * popup is the case: MiniPopUp's panel is the surface, and a card nested in it
 * drew a second border, a second radius and a second shadow inside the first,
 * with the card's own --s5 bottom margin left over as a strip below it. That
 * was the second panel edge visible at the bottom of every filter popup. Bare
 * keeps the head and the body — only the surface belongs to the host.
 */
export const BoxContainer = styled.div`
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  box-shadow: var(--sh-1);
  margin-bottom: var(--s5);

  &.flush {
    overflow: hidden;
  }

  &.bare {
    border: none;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 0;
    background: none;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s3);
  padding: var(--s4) var(--s5);
  border-bottom: 1px solid var(--line);
`;

export const TitleCon = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s2);
  min-width: 0;
`;

export const Icon = styled.div`
  line-height: 0;
  color: var(--text-faint);
`;

export const Title = styled.h4`
  margin: 0;
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-body);
  letter-spacing: -0.005em;
  color: var(--text);
`;

export const Hint = styled.span`
  font-size: var(--fs-label);
  color: var(--text-faint);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* right-hand action slot */
export const Div = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--s2);
`;

export const Content = styled.div`
  padding: var(--s5);
`;
